import { isDefined } from '@morpho-org/morpho-ts'

/**
 * Final vault position (in assets) after a withdraw, clamped to never go
 * negative. Returns `undefined` when there's no input or the current position
 * is unknown. `isClosePosition` (MAX capped by the user's own balance → redeem
 * all shares) resolves to a clean 0 with no dust.
 */
export const computeWithdrawFinalPosition = ({
  userVaultAssets,
  inputAmount,
  isClosePosition
}: {
  userVaultAssets: bigint | undefined
  inputAmount: bigint
  isClosePosition: boolean
}): bigint | undefined => {
  if (!inputAmount || !isDefined(userVaultAssets)) return undefined
  if (isClosePosition) return 0n
  const result = userVaultAssets - inputAmount
  return result < 0n ? 0n : result
}
